import React from 'react';
import inflection from 'inflection';
import moment from 'moment';

import BasicTable, { Column, ROW_HEIGHTS } from 'buyside/components/presentation/Table/basicTable';

const formatTitle = unformattedTitle => {
  const mappings = {
    rankString: 'Ranking',
    createdAt: 'Date'
  };
  return mappings[unformattedTitle];
};

const extractColumn = (ranks, columnTitle) => {
  const column = [];
  ranks.forEach(rank => {
    switch (columnTitle) {
      case 'rankString':
        column.push(inflection.titleize(rank[columnTitle]));
        break;
      case 'createdAt':
        const date = new Date(rank[columnTitle]);
        column.push(moment(date).format('MMMM YYYY'));
        break;
    }
  });

  return column;
};

const RanksTable = ({ ranks }) => {
  const columnTitles = Object.keys(ranks[0]).filter(str => str !== '__typename');
  const columns = columnTitles.map(title => extractColumn(ranks, title));

  return (
    <BasicTable columns={columns} rowHeight={ROW_HEIGHTS.LARGE}>
      {columnTitles.map((columnTitle, idx) => {
        return <Column idx={idx} key={idx} heading={formatTitle(columnTitle)} />;
      })}
    </BasicTable>
  );
};

export default RanksTable;
